import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useUIStore } from '@/store/uiStore';
import { cn } from '@/utils/cn';
import { SoftphoneWidget } from '../softphone/SoftphoneWidget';

export function Layout() {
  const sidebarOpen = useUIStore((state) => state.sidebarOpen);

  return (
    <div className="h-screen flex overflow-hidden bg-gray-50">
      <Sidebar />

      <div className="flex flex-col flex-1 overflow-hidden">
        <Header />

        <main
          className={cn(
            'flex-1 overflow-y-auto transition-all duration-300',
            'focus:outline-none'
          )}
        >
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <Outlet />
            </div>
          </div>
        </main>

        <Footer />
      </div>
      <SoftphoneWidget />
    </div>
  );
}

export default Layout;
